import { schema } from 'normalizr'

import * as schemas from './individual.schema'

export const alSchema = new schema.Entity('alContainer', {
    MLEXLOG: [schemas.MLEXLOG],
    MLAQUATICS: [schemas.MLAQUATICS],
    MLEVAL: [schemas.MLEVAL],
    MLFCEPOET: [schemas.MLFCEPOET],
    MLGAIT: [schemas.MLGAIT],
    MLMANUAL: [schemas.MLMANUAL],
    MLMODALITIES: [schemas.MLMODALITIES],
    MLNEURO: [schemas.MLNEURO],
    MLOTHER: [schemas.MLOTHER],
    MLPHYSRECOND: [schemas.MLPHYSRECOND],
    MLSELFCARE: [schemas.MLSELFCARE],
    MLSPECIALTYTESTS: [schemas.MLSPECIALTYTESTS],
    MLSPEECH: [schemas.MLSPEECH],
    MLWORKPROG: [schemas.MLWORKPROG],
    MLTHERACT: [schemas.MLTHERACT],
    MLTHEREX: [schemas.MLTHEREX],
    MLWORKHARD: [schemas.MLWORKHARD],
});
